import React, { useState } from 'react';
export function MGAInformation() {
  const [mgaPercentage, setMgaPercentage] = useState(25);
  const [brokerPercentage, setBrokerPercentage] = useState(15);
  const [selectedLine, setSelectedLine] = useState('Life');
  const [selectedSubLine, setSelectedSubLine] = useState('');
  const insuranceLines = ['Life', 'P&C', 'Motor', 'Specialty'];
  const subLines = {
    Life: ['Term Life', 'Whole Life', 'Universal Life'],
    'P&C': ['Property', 'Casualty', 'Liability'],
    Motor: ['Private Car', 'Commercial', 'Motorcycle'],
    Specialty: ['Marine', 'Aviation', 'Cyber']
  };
  return <div className="bg-white rounded-lg shadow p-6 max-w-3xl" data-id="element-390">
      <h2 className="text-xl font-semibold mb-6" data-id="element-391">MGA Information</h2>
      <div className="space-y-6" data-id="element-392">
        <div data-id="element-393">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-394">
            MGA % of premium: {mgaPercentage}%
          </label>
          <div className="flex items-center gap-4" data-id="element-395">
            <input type="range" min="0" max="100" value={mgaPercentage} onChange={e => setMgaPercentage(parseInt(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer" data-id="element-396" />
            <input type="number" min="0" max="100" value={mgaPercentage} onChange={e => setMgaPercentage(parseInt(e.target.value))} className="w-20 p-2 border rounded-md" data-id="element-397" />
          </div>
        </div>
        <div data-id="element-398">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-399">
            Broker % of premium: {brokerPercentage}%
          </label>
          <div className="flex items-center gap-4" data-id="element-400">
            <input type="range" min="0" max="100" value={brokerPercentage} onChange={e => setBrokerPercentage(parseInt(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer" data-id="element-401" />
            <input type="number" min="0" max="100" value={brokerPercentage} onChange={e => setBrokerPercentage(parseInt(e.target.value))} className="w-20 p-2 border rounded-md" data-id="element-402" />
            <button className="px-3 py-1 text-sm bg-gray-200 rounded hover:bg-gray-300" data-id="element-403">
              Use Average
            </button>
          </div>
        </div>
        <div data-id="element-404">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-405">
            Insurance Line
          </label>
          <select value={selectedLine} onChange={e => {
          setSelectedLine(e.target.value);
          setSelectedSubLine('');
        }} className="w-full p-2 border rounded-md" data-id="element-406">
            {insuranceLines.map(line => <option key={line} value={line} data-id="element-407">
                {line}
              </option>)}
          </select>
        </div>
        <div data-id="element-408">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-409">
            Sub-line
          </label>
          <select value={selectedSubLine} onChange={e => setSelectedSubLine(e.target.value)} className="w-full p-2 border rounded-md" data-id="element-410">
            <option value="" data-id="element-411">Select a sub-line</option>
            {selectedLine && subLines[selectedLine as keyof typeof subLines].map(subLine => <option key={subLine} value={subLine} data-id="element-412">
                  {subLine}
                </option>)}
          </select>
        </div>
        <div data-id="element-413">
          <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-414">FCA Lookup</h3>
          <div className="flex items-center gap-2" data-id="element-415">
            <input type="text" placeholder="Enter MGA details" className="flex-1 p-2 border rounded-md" data-id="element-416" />
            <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700" data-id="element-417">
              Search
            </button>
          </div>
          <p className="mt-2 text-sm text-gray-500" data-id="element-418">
            Lookup MGA details from FCA Developer API
          </p>
          <a href="#" className="mt-1 text-sm text-blue-600 hover:underline" data-id="element-419">
            FCA Developer API
          </a>
        </div>
      </div>
    </div>;
}